import { IS_OPEN_SENTRY, LOCAL_STORAGE } from '@/constant';
import * as Sentry from '@sentry/react';
import { Button, Result } from 'antd';
import type { ErrorInfo } from 'react';
import React from 'react';
class CustomBoundary extends React.Component<
  Record<string, any>,
  { hasError: boolean; errorInfo: string }
> {
  state = { hasError: false, errorInfo: '' };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, errorInfo: error.message };
  }

  componentDidCatch(error: any, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    // eslint-disable-next-line no-console
    console.log(error, errorInfo);
    if (IS_OPEN_SENTRY) {
      const { uid, cid, token } = JSON.parse(localStorage.getItem(LOCAL_STORAGE.tokenInfo) || '{}');
      Sentry.captureException(new Error(error), {
        level: 'fatal',
        user: { uid, cid, token },
      });
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        // eslint-disable-next-line react/jsx-no-undef
        <Result
          icon={
            <img
              width={256}
              src="https://gw.alipayobjects.com/zos/antfincdn/zIgkN%26mpMZ/shibaizhuangtaizuo.png"
            />
          }
          style={{
            height: '100%',
            background: '#fff',
          }}
          title="错误处理"
          extra={
            <>
              <div
                style={{
                  maxWidth: 620,
                  textAlign: 'start',
                  backgroundColor: 'rgba(255,229,100,0.3)',
                  borderInlineStartColor: '#ffe564',
                  borderInlineStartWidth: '9px',
                  borderInlineStartStyle: 'solid',
                  padding: '20px 45px 20px 26px',
                  margin: 'auto',
                  marginBlockEnd: '30px',
                  marginBlockStart: '20px',
                }}
              >
                {/* <p>注意</p>
                <p>
                  错误边界<strong>无法</strong>捕获以下场景中产生的错误：
                </p> */}
                <ul
                  style={{
                    listStyle: 'none',
                  }}
                >
                  <li>哦豁~页面崩溃啦，请刷新页面哦！😂 </li>
                </ul>
              </div>
              <Button
                danger
                type="primary"
                onClick={() => {
                  window.location.reload();
                }}
              >
                刷新页面
              </Button>
            </>
          }
        />
      );
    }
    return this.props.children;
  }
}

export default CustomBoundary;
